module.exports = __webpack_public_path__ + "images/1c1b2a17b641d003d161813b3c4a2fe5.png";